import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { variables } from '../Variables/Variable';
import { toast } from 'react-toastify';
import ReCaptcha from '../Components/ReCaptcha';
import Honeypot from '../Components/Honeypot';
const Contact = () => {
    const ID = useParams();
    const [name,setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone,setPhone] = useState("");
    const [message,setMessage] = useState("");
    const [captchaToken,setCaptchaToken] = useState("");
    const [website,setWebsite] = useState("");
    const [menu,setMenu] = useState([]);
    var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    function isValid() {

          //Registration
          if ( email == "" || name == "" || phone == "" || message == "" ) {
            toast.error("please fill required fields");
            return false;
          } else if (!emailregx.test(email)){
            toast.error("Bad email format");
            return false;
          } else if (captchaToken == "") {
            toast.error("Please verify that you are not a robot");
            return false;
          }else {
            return true;
          }
      }
      const getMenuDetails = () => {
        fetch(variables.API_URL + "Menu/GetMenuDetails/" + 9, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((Response) => {
                if (Response.ok) {
                    return Response.json();
                }
            })
            .then((Result) => {
                setMenu(Result)
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

     if(isValid()){
        fetch(variables.API_URL + "Contact/SendContactEmail/", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
            body: JSON.stringify({
                Name: name,
                Email: email,
                PhoneNumber: phone,
                Message: message,
                RecaptchaToken: captchaToken,
                Website: website
              }),
        })
            .then((Response) => {
                if (Response.ok) {
                    toast.success("Email sent Sucessfully");
                    setName("");
                    setPhone("");
                    setEmail("");
                    setMessage("");
                    setCaptchaToken("");
                    if (window.grecaptcha) window.grecaptcha.reset();
                    return Response.json();
                } else {
                    toast.error("Verification failed, please try again");
                    setCaptchaToken("");
                    if (window.grecaptcha) window.grecaptcha.reset();
                }
            })
     }
    }
    useEffect(() => {
        getMenuDetails();
    },[name,phone,email,message])


    return (
        <>
            {/* <!--Start Page Header--> */}
            <section className="page-header">
                <div className="page-header__bg" style={{ backgroundImage: `url(${variables.PHOTO_URL + menu.ImageUrl})` }}>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-header__wrapper">
                                <div className="page-header__content">
                                    <h2>{ID.MenuTitle}</h2>
                                    <div className="page-header__menu">
                                        <ul>
                                            <li><a hreflang="en" href="/">Home</a></li>
                                            <li>{ID.MenuTitle}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--End Page Header--> */}



            {/* <!--Contact Page Google Map Start--> */}
            <section className="contact-page-google-map">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3313.506234821663!2d35.508724515165966!3d33.85084218066128!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f1762cced8115%3A0xe903d839811fc68!2sHome%20Depot%20of%20Lebanon!5e0!3m2!1sen!2slb!4v1672230048785!5m2!1sen!2slb"
                    className="contact-page-google-map__one" allowfullscreen></iframe>
            </section>
            {/* <!--Contact Page Google Map End--> */}




            {/* <!--Start Contact Page--> */}
            <section className="contact-page">
                <div className="container">
                    <div className="row">
                        {/* <!--Start Get In Touch--> */}
                        <div className="col-xl-4 col-lg-6">
                            <div className="contact-page__get-in-touch">
                                <div className="title">
                                    <h2>Stay in touch with us</h2>
                                    <p>You can also reach out to us by phone <br />or email are many variations</p>
                                </div>

                                <ul>
                                    <li>
                                        <div className="icon rotate">
                                            <span className="fa fa-phone"></span>
                                        </div>
                                        <div className="text">
                                            <span>Contact info</span>
                                            <p className="telephone">Telephone : <a hreflang="en" href="tel:01558517">+ 961 1 558517/+961 8 554546</a></p>
                                            <p className="mobile">Mobile : <a hreflang="en" href="tel:76757502">+ 961 76 757502 / + 961 3 778765</a></p>
                                            <p className="mobile">Fax : <a hreflang="en" href="tel:015554546">+ 961 1 554546</a></p>
                                            <p className="mobile">P.O. Box: 24/44 Haret Hreik Blvd, Beirut, Lebanon</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="icon bg2">
                                            <span className="fa fa-map-marker"></span>
                                        </div>
                                        <div className="text">
                                            <span>Address</span>
                                            <p>Sibai Center, Al Aried St.<br /> Haret Hreik, Lebanon</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {/* <!--End Get In Touch--> */}



                        {/* <!--Start Contact Page Comment Form--> */}
                        <div className="col-xl-8 col-lg-6">
                            <div className="contact-page__comment-form">
                                <div className="title">
                                    <h2>Get in touch</h2>
                                    
                                </div>
                                {/* novalidate="novalidate" */}
                                {/* className="comment-one__form contact-form-validated" */}
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="comment-form__input-box">
                                                <input type="text" placeholder="User Name" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="comment-form__input-box">
                                                <input type="email" placeholder="Email" value={email} name="email" onChange={(e) => setEmail(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xl-12 col-lg-12">
                                            <div className="comment-form__input-box">
                                                <input type="text" placeholder="Phone" value={phone} name="phone" onChange={(e) => setPhone(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="comment-form__input-box">
                                                <textarea name="message" placeholder="Your Message here" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                                            </div>
                                            <Honeypot value={website} onChange={(e) => setWebsite(e.target.value)} />
                                            <div className="comment-form__input-box" style={{ marginBottom: 20 }}>
                                                <ReCaptcha onChange={setCaptchaToken} />
                                            </div>
                                            <button dis type="submit" className="thm-btn comment-form__btn">
                                                Send Message
                                            </button>
                                            {/* <button type="submit">
                                                Send Message
                                            </button> */}
                                            
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <!--End Contact Page Comment Form--> */}

                    </div>
                </div>
            </section>
            {/* <!--End Contact Page--> */}

        </>
    )
}

export default Contact